export const dbSignup = 
    {
        status: true,
        message: "Account Created Sucessfully"
    }


